import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { FamilySchema } from '..'

export const SearchSchema = z.object({
  // Entrée de sidebar dont dépend cette page (cf. la route parente). Le type du calendrier n'étant pas
  // dans l'URL, les appelants qui le connaissent la passent (l'éclairage notamment) ; à défaut c'est
  // « general », la famille des calendriers de température.
  family: FamilySchema.default('general'),
})

export type Search = z.infer<typeof SearchSchema>

export const Route = createFileRoute('/_dashboard/site/$id/operation/scheduler/$scheduleId/')({
  validateSearch: SearchSchema,
})
